import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Team", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Blurb on Teams")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userLocation), 1),
                _hoisted_2,
                _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis nisi, aperiam provident sapiente nemo qui consectetur, libero sed dolore voluptates velit accusamus voluptatem aspernatur inventore ex voluptate mollitia dolorem cupiditate? ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Returned Axios Data "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userLocation, (user, i) => {
                  return (_openBlock(), _createBlock(_component_v_list, {
                    density: "compact",
                    key: i
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" User ID: " + _toDisplayString(user.user), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Modifed By: " + _toDisplayString(user.modified_by), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Branch: " + _toDisplayString(user.branch), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}